import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.29.0_@playwright+test@1.61.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsBridge"] */ "/app/src/components/analytics-bridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthDialogProvider"] */ "/app/src/components/auth-dialog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/components/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/src/components/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RuntimeErrorMonitor"] */ "/app/src/components/runtime-error-monitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteChrome"] */ "/app/src/components/site-chrome.tsx");
